import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { joinClasses, callService, checkValidity } from 'utils/utility';
import { calvh } from 'utils/element';
import { errorAlert, warningAlert } from 'utils/alert';
import { login } from 'services/auth';
import { useImagesContext } from 'contexts/ImagesContext';
import { useDispatch } from 'react-redux';
import * as decisionActions from 'actions/decision';
import * as authActions from 'actions/auth';
import * as trainerActions from 'actions/trainer';
import Progress from 'components/fragments/Progress';
import ButtonOK from 'components/fragments/ButtonOK';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    height: '100%',
    width: '100%',
  },
  'container-login': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '60vw',
    height: calvh('10vh'),
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 70%',
    backgroundPosition: 'center',
  },
  'input-login': {
    fontSize: calvh('3vh'),
    fontWeight: 600,
    margin: '.5rem',
    borderColor: 'transparent',
    width: '100%',
    //lineHeight: '3rem',
    '&:focus': {
      outline: 'none',
    },
  },
  'img-logo': {
    objectFit: 'contain',
    height: calvh('32vh'),
    width: '60vw',
  },
  'text-placeholder': {
    fontSize: calvh('5.8vh'),
    color: '#6c2a12',
    textShadow: `#fff ${calvh('0.1vh')} ${calvh('0.1vh')} 0px, #fff ${calvh(
      '-0.1vh'
    )} ${calvh('-0.1vh')} 0px, #fff 0px ${calvh(
      '-0.16vh'
    )} 0px, #fff 0px ${calvh('0.16vh')} 0px`,
  },
  'img-warning': {
    height: calvh('13vh'),
    maxWidth: '90vw',
    paddingTop: calvh('1vh'),
    objectFit: 'contain',
  },
  'container-devider': {
    width: '35%',
    height: calvh('0.36vh'),
    backgroundColor: '#6c2912',
  },
}));

const Login = (props) => {
  const { images } = useImagesContext();
  const c = joinClasses(useStyles({ ...props }));
  const [form, setForm] = React.useState({});
  const [loginFlag, setLoginFlag] = React.useState({});
  const dispatch = useDispatch();

  const handleClickLogin = () => {
    const { valid, message } = handleValidate();
    if (valid) {
      handleLoginService();
    } else {
      warningAlert(undefined, message);
    }
  };

  const handleValidate = () => {
    console.log('form:', checkValidity(form['code'], { required: true }));
    let valid = true;
    let message = '';
    if (!checkValidity(form['code'], { required: true })) {
      valid = false;
      message = 'กรุณาระบุ code';
    }
    return { valid, message };
  };

  const handleChangeForm = (event, field) => {
    const value = event.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleLoginService = (next) => {
    callService(
      login,
      { code: form['code'] },
      setLoginFlag,
      (resp) => {
        dispatch(trainerActions.setTrainerInfo(resp?.teacher));
        //dispatch(authActions.setAuthenSuccess());
        if (resp?.teacher?.videoDone) {
          dispatch(decisionActions.setActiveState('schedule'));
        } else {
          dispatch(decisionActions.setActiveState('introduce'));
        }
        next && next(resp);
      },
      (error) => {
        errorAlert(error);
      }
    );
  };

  const pendingFlag = React.useMemo(
    () => loginFlag.request,
    [loginFlag.request]
  );

  const successFlag = React.useMemo(
    () => loginFlag.success,
    [loginFlag.success]
  );

  return (
    <div className={c('root')}>
      {pendingFlag ? <Progress /> : null}
      <Grid container justifyContent='center' alignItems='center'>
        <Grid item xs={12} container justifyContent='center'>
          <img
            className={c('img-logo')}
            src={images['student-login-logo.png']}
          />
        </Grid>
        <Grid item xs={12} container justifyContent='center'>
          <div
            className={c('container-login')}
            style={{
              backgroundImage: `url(${images['student-login-field.png']})`,
            }}
          >
            <input
              className={c('input-login')}
              onChange={(e) => handleChangeForm(e, 'code')}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          container
          justifyContent='center'
          style={{ flexWrap: 'wrap' }}
        >
          <div className={c('text-placeholder')}>กรอกรหัสประจำตัว</div>
          <div className={c('text-placeholder')}>เพื่อเข้าระบบ</div>
        </Grid>
        <Grid
          item
          xs={12}
          container
          justifyContent='center'
          style={{ padding: '10px 0px' }}
        >
          <div className={c('container-devider')} />
        </Grid>
        <Grid
          item
          xs={12}
          container
          justifyContent='center'
          style={{ flexWrap: 'wrap' }}
        >
          <div className={c('text-placeholder')}>ENTER USER PERSONAL ID</div>
          <div className={c('text-placeholder')}>TO LOGIN</div>
        </Grid>
        <Grid
          item
          xs={12}
          container
          justifyContent='center'
          style={{ marginTop: '1vh' }}
        >
          <ButtonOK onClick={handleClickLogin} />
        </Grid>
      </Grid>
    </div>
  );
};

export default Login;
